import { render, staticRenderFns } from "./TV2.vue?vue&type=template&id=095a98fa&scoped=true&"
import script from "./TV2.vue?vue&type=script&lang=js&"
export * from "./TV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095a98fa",
  null
  
)

export default component.exports